import axios from "axios";
import { publishProjectUrl } from "../../utils";

export const publishProject = (id: string) => {
  return axios.post(publishProjectUrl(id));
};
